export default __webpack_public_path__ + "static/media/sampleQbProductFile.8380368b.csv";